import { ChatTheme, COLORS_SCHEME_DARK } from "../../types";

export const detectColorMode = (): ChatTheme => {
  if (window.matchMedia && window.matchMedia(COLORS_SCHEME_DARK).matches) {
    return ChatTheme.dark;
  }
  return ChatTheme.light;
};
